import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useListenSize from '../hooks/useListenSize';
import WarningCircle from '../assets/img/warning-circle.svg';
import { segmentEvent } from '../helpers/sendEvent';

// eslint-disable-next-line no-shadow
function Error() {
  const store = useSelector(state => ({
    error: state?.technical?.error,
    integrationType: state?.technical?.initialize?.integrationType,
  }));
  useListenSize();
  useEffect(() => {
    segmentEvent('page', 'General Error');
  }, []);
  const goBackToRetailor = () => {
    const payload = JSON.parse(
      JSON.stringify({
        katapultSDK: 'payment-fail',
        payload: {
          code: 'HTTP-ERROR',
          message: store.error,
        },
      }),
    );
    window?.parent?.postMessage(payload, '*');
  };

  return (
    <div className="k-content-wrapper">
      <section className="k-info">
        <h1>Thanks for applying</h1>
        <div className="k-error-image-wrapper">
          <img width="150px" height="150px" className="error-icon" src={WarningCircle} alt="" />
        </div>
        {store.integrationType !== 'storis' && <p>Unfortunately we are unable to complete your transaction.</p>}
        {store.integrationType === 'storis' && <p>Unfortunately we were unable to approve you at this time</p>}
        {store.integrationType !== 'storis' && (
          <div className="k-submit k-error-button">
            <button type="button" onClick={goBackToRetailor}>
              Back to Retailer
            </button>
          </div>
        )}
      </section>
    </div>
  );
}

export default Error;
